import React, { useEffect, useState } from "react";
import Conf from "./Conf";
import Grid from "@material-ui/core/Grid";
import PersonalReceptTable from "./components/PersonalReceptTable";
import { getPermission } from "./js/main";

const cookie = JSON.parse(localStorage.getItem(Conf.cookieName));
export default function PrintDelivery() {
  const [profile, setProfile] = useState(null);
  const [bills, setBills] = useState(null);

  useEffect(() => {
    async function getAuth() {
      if (cookie && cookie.token) {
        var auth = await getPermission(cookie.token);
        if (auth.profile && auth.profile.usn) {
          setProfile(auth.profile);

          if (cookie.print) {
            setBills(cookie.print);
          }
        }
      }
    }
    if (!profile) getAuth();
  }, [profile]);

  useEffect(() => {
    if (bills) {
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  }, [bills]);
  return (
    <div style={{ padding: "0px", margin: "0px" }}>
      {bills && (
        <>
          <PersonalReceptTable
            bills={bills.bills}
            sumation={bills.sumation}
            subTitle={bills.subTitle}
          />
          <br />
          <br />
          <br />
          <Grid container>
            <Grid item xs={6}></Grid>
            <Grid item xs={6} style={{ textAlign: "center" }}>
              ...............................................................................................
              <div>
                ({profile.PrenameTha}
                {profile.NameTha} {profile.SurNameTha})<br />
                ผู้ส่งเงิน
              </div>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}
